import dayjs from 'dayjs';
const state = {
  rangeTime: 0,
  countTime: '',
  showTime: true,
  showRpRain: false,
  showVideo: true,
};

const mutations = {
  setRangeTime(state, number) {
    state.rangeTime = number;
  },
  setCountTime(state, string) {
    state.countTime = string;
  },
  setShowTime(state, bool) {
    state.showTime = bool;
  },
  setShowRpRain(state, bool) {
    state.showRpRain = bool;
  },
  setShowVideo(state, bool) {
    state.showVideo = bool;
  },
};

const actions = {
  // 事件
  async getTimesInfo({ commit }) {
    const startTime = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + '9:00');
    const endTime = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + '23:59');
    const todayTime = dayjs();
    let countTime;
    let rangeTime;
    let rangeYearTime;
    if (todayTime.diff(startTime) < 0) {
      //   当前时间小于开始时间
      countTime = todayTime.format('MM-DD') + ' ' + '09:00';
      rangeTime = startTime.diff(todayTime);
    } else if (todayTime.diff(startTime) > 0 && todayTime.diff(endTime) < 0) {
      const timerShi = todayTime.format('YYYY-MM-DD') + ' ' + todayTime.hour();
      const timerAdd = todayTime.format('YYYY-MM-DD') + ' ' + todayTime.add(1, 'hour').hour() + ':00';
      //    当前时间大于9:00小于23:59
      if (todayTime.diff(dayjs(timerShi + ':00')) >= 0 && todayTime.diff(dayjs(timerShi + ':30')) < 0) {
        //    当前时间在半点之内
        rangeYearTime = timerShi + ':30';
        countTime = todayTime.format('MM-DD') + ' ' + todayTime.hour() + ':30';
      } else if (todayTime.diff(dayjs(timerShi + ':30')) >= 0 && todayTime.diff(dayjs(timerAdd)) < 0) {
        //    当前时间在半点之外
        rangeYearTime = todayTime.format('YYYY-MM-DD') + ' ' + todayTime.add(1, 'hour').hour() + ':00';
        countTime = todayTime.format('MM-DD') + ' ' + todayTime.add(1, 'hour').hour() + ':00';
      }
      rangeTime = dayjs(rangeYearTime).diff(todayTime);
    }
    commit('setCountTime', countTime);
    commit('setRangeTime', rangeTime);
  },
  // 倒计时结束开始红包雨
  async onFinishTime({ commit, dispatch }) {
    commit('user/rainChance', false, { root: true });
    dispatch('onShowRain');
  },
  // 红包时间结束
  async onFinish({ commit, dispatch }, score) {
    commit('setShowRpRain', false);
    await dispatch('lottery/clickLottery', score, { root: true });
    await dispatch('getTimesInfo');
    commit('setShowTime', true);
  },
  // 步骤
  async onShowRain({ commit, rootState }) {
    const startTime = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + '9:00');
    const endTime = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + '23:59');
    const todayTime = dayjs();
    const {
      user: { userInfo },
    } = rootState;
    if (!userInfo.is_rain && todayTime.diff(startTime) > 0 && todayTime.diff(endTime) < 0) {
      commit('setRangeTime', 0);
      commit('setShowTime', false);
      commit('setShowRpRain', true);
      commit('setShowVideo', false);
    } else {
      commit('setShowRpRain', false);
      commit('setShowTime', true);
      commit('setShowVideo', true);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
